export default {
  props: {
    form: {
      type: Object,
      required: true,
    },

    name: {
      type: String,
      required: true,
    },

    modelValue: {
      type: [String, Number],
      required: true,
      default: '',
    },

    label: {
      type: String,
      required: true,
    },

    isRequired: {
      type: Boolean,
      required: false,
      default: true,
    },

    placeholder: {
      type: String,
      required: false,
      default: '',
    },

    classes: {
      type: String,
      required: false,
      default: 'border-2',
    },
  },

  computed: {
    errorClasses() {
      if (this.form.errors && this.form.errors[this.name]) {
        return 'text-red-500 border-red-500 focus:border-red-500';
      }

      return 'focus:border-red';
    },
  },
};
